import LayoutWithSidebar from '../components/common/layoutWithSidebar';
import AgentCreationWizardFlow from '../components/UserJourny/AgentCreationWizard/AgentCreationWizardFlow';

const AgentCreationWizard = () => {
  return (
    <LayoutWithSidebar hideFooter disableMainScroll>
      <AgentCreationWizardFlow />
    </LayoutWithSidebar>
  );
};

export default AgentCreationWizard;
